import useApiHook from '../../../../hooks/api/useApiHook';
import { useCallback } from 'react';

export const useGetPricing = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getPricing = useCallback(async () => {
    const url = `/trading-config/pricing`;
    await get(url);
  }, [get]);

  return { getPricing, data, error, loading };
};

export const usePostPricing = () => {
  const { post, data, error, loading } = useApiHook(true);

  const postPricing = useCallback(
    async (body) => {
      const url = `/trading-config/pricing`;
      await post(url, body);
    },
    [post],
  );

  return { postPricing, data, error, loading };
};

export const useGetPurchaseStep = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getPurchaseStep = useCallback(
    async (commodity) => {
      const url = `/trading-config/volumes?commodity=${commodity}`;
      await get(url);
    },
    [get],
  );

  return { getPurchaseStep, data, error, loading };
};

export const usePostPurchaseStep = () => {
  const { post, data, error, loading } = useApiHook(true);

  const postPurchaseStep = useCallback(
    async (commodity, body) => {
      const url = `/trading-config/volumes?commodity=${commodity}`;
      await post(url, body);
    },
    [post],
  );

  return { postPurchaseStep, data, error, loading };
};

export const usePostContractVolumeExport = () => {
  const { post, data, error, loading } = useApiHook(true);

  const postContractVolumeExport = useCallback(
    async (query) => {
      await post(`/summary-contracts/volume/export`, query, { responseType: 'blob' });
    },
    [post],
  );

  return { postContractVolumeExport, data, error, loading };
};

export const useGetCommodities = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getCommodities = useCallback(async () => {
    const url = `/enums/commodities`;
    await get(url);
  }, [get]);

  return { getCommodities, data, error, loading };
};

export const usePutCommodities = () => {
  const { put, data, error, loading } = useApiHook(true);

  const putCommodities = useCallback(
    async (commodities) => {
      const url = `/enums/commodities`;
      await put(url, commodities);
    },
    [put],
  );

  return { putCommodities, data, error, loading };
};

export const useGetMobileCardConfiguration = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getMobileCardConfiguration = useCallback(async () => {
    const url = `/notifications-configuration/mobile-card`;
    await get(url);
  }, [get]);

  return { getMobileCardConfiguration, data, error, loading };
};

export const usePutMobileCardConfiguration = () => {
  const { put, data, error, loading } = useApiHook(true);

  const putMobileCardConfiguration = useCallback(
    async (mobileCardConfiguration) => {
      const url = `/notifications-configuration/mobile-card`;
      await put(url, mobileCardConfiguration);
    },
    [put],
  );

  return { putMobileCardConfiguration, data, error, loading };
};

export const useSendMobileNotificationsManually = () => {
  const { get, error, loading } = useApiHook(true);

  const sendMobileNotifications = useCallback(
    async (mobileCardConfiguration) => {
      const url = `/notifications/send-mobile-notifications`;
      await get(url, mobileCardConfiguration);
    },
    [get],
  );

  return { sendMobileNotifications, error, loading };
};

export const useFindNotificationImpulses = () => {
  const { post, data, error, loading } = useApiHook();
  const postFindNotificationImpulses = useCallback(
    async ({ page, size }) => {
      const url = '/notifications-configuration/find-notification-impulses';
      await post(url, { page, size });
    },
    [post],
  );
  return { postFindNotificationImpulses, data, error, loading };
};

export const useGetEndDates = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getEndDates = useCallback(
    async (contractPeriod) => {
      contractPeriod = contractPeriod ? `?year=${contractPeriod}` : '';
      const url = `/contracts/defaultContractDates${contractPeriod}`;
      await get(url);
    },
    [get],
  );

  return { getEndDates, data, error, loading };
};

export const usePostEndDates = () => {
  const { post, data, error, loading } = useApiHook(true);

  const postEndDates = useCallback(
    async (endDatesData) => {
      const url = `/contracts/defaultContractDates`;
      await post(url, endDatesData);
    },
    [post],
  );

  return { postEndDates, data, error, loading };
};
